import { useParams } from 'react-router'
import { useSnapshot } from 'valtio'
import { RingBadge } from '@/components/Badge/Badge'
import { ErrorDisplay } from '@/components/Error/Error'
import { ItemDetail } from '@/components/ItemDetail/ItemDetail'
import { ItemList } from '@/components/ItemList/ItemList'
import { Layout } from '@/components/Layout/Layout'
import { QuadrantLink } from '@/components/QuadrantLink/QuadrantLink'
import { getLatestRelease, sortByTitle } from '@/lib/data'
import { state } from '@/lib/state'
import type { Item } from '../../../../types'
import styles from './[id].module.css'

const ItemPage = () => {
  const { isLoading, radarConfig, radarItems } = useSnapshot(state)
  const labels = radarConfig?.labels || {}
  const quadrants = radarConfig?.quadrants || []
  const { quadrantId, itemId } = useParams()

  if (isLoading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-screen">
          <div className="text-[var(--ds-text-subtle)]">Loading...</div>
        </div>
      </Layout>
    )
  }

  const quadrant = quadrants.find(q => q.id === quadrantId)
  const item = radarItems.find(i => i.id === itemId)
  if (!item)
    return <ErrorDisplay error={new Error(`Item ${itemId} not found`)} />

  const overviewLabel = labels.quadrantOverview

  if (!quadrant || !item) return null

  const itemLatestRelease = getLatestRelease(item as Item)
  if (!itemLatestRelease) return null

  const relatedItems = (radarItems as Item[])
    .filter(i => {
      const latestRelease = getLatestRelease(i)
      return (
        i.quadrant === quadrant.id &&
        latestRelease?.ring === itemLatestRelease.ring
      )
    })
    .sort(sortByTitle)

  return (
    <Layout>
      <div className={styles.layout}>
        <section className={styles.content}>
          <ItemDetail item={item as Item} />
        </section>
        <aside className={styles.sidebar}>
          <div className="pb-5">
            <h3>{quadrant.title}</h3>
          </div>
          <div className={styles.ringAndQuadrant}>
            <RingBadge ring={itemLatestRelease.ring} />
            <QuadrantLink quadrant={quadrant} label={overviewLabel} />
          </div>

          <ItemList items={relatedItems} activeId={item.id} />
        </aside>
      </div>
    </Layout>
  )
}

export default ItemPage
